export default function round (num, decimalPlaces=1) {
  return Math.round(num * (10 * decimalPlaces)) / (10 * decimalPlaces)
}
